<template>
    <div :class="['wrapper--page page-inner', name]">

        <div class="page__wrap top">
            <arrow-button
                type="top"
                text="Back"
                :label="backButton.label"
                @click.native="() => $router.push(backButton.route)"
            />
        </div>

        <page-main tag="main" class="wrapper--body">
            <transition appear name="load" mode="out-in">
                <slot name="body" />
            </transition>
    
            <transition appear name="load">
                <PageNav 
                    v-bind="{ navTitle, navTitleId, routeName, items }"
                />
            </transition>
        </page-main>

        <AwardLogos />

        <SlideLines />

        <SplashImage
            v-if="!bullets"
            :count="2"
        />

        <Copyright />

    </div>
</template>

<script>
import PageNav      from './PageNav'
import AwardLogos   from './Ui/AwardLogos'
import SlideLines   from './Slide/SlideLines'

// const SlideBullets = {
//     props: {
//         bullets: {
//             type: Array,
//             required: true
//         },
//     },
//     components: {
//         BulletBox,
//         PageNav,
//     },
//     render(h) {
//         return h('div', {
//             class: 'bullets'
//         }, [
//             this.bullets.map(bullet => h(
//                 BulletBox,
//                 {
//                     props: {
//                         color: bullet.color,
//                         size: bullet.size,
//                         blur: bullet.blur,
//                     },
//                 }
//             ))
//         ])
//     }
// }

export default {
    props: {
        navTitle: String,
        navTitleId: String,
        routeName: String,
        name: {
            type: String,
            default: 'members'
        },
        backButton: {
            type: Object,
            required: true
        },
        items: {
            type: [Array, Object],
            required: true
        },
        bullets: {
            type: [Array, Object],
            required: false
        },
    },
    
    components: {
        PageNav,
        SlideLines,
        AwardLogos,
    },

    created() {
        this.rootClass('rm')
        this.mobileClass('add', '-viewport')
    },

    activated() {
        this.rootClass('rm')
        this.mobileClass('add', '-viewport')
    },
}
</script>